<template>
    <InertiaLink
        v-if="href"
        :href="href"
        :method="method"
        :as="method == 'post' ? 'button' : as"
        class="hover:text-gray-200 transition-all duration-300 border border-transparent cursor-pointer rounded flex justify-center items-center"
        :class="{
            ['hover:bg-'+ color +'-900 hover:border-'+ color +'-900 text-'+ color +'-600'] : color,
            ['bg-transparent'] : !color,
        }"
    >
        <Svg
            :name="icon"
            :size="size"
        />
        <slot name="addon" />
    </InertiaLink>
    <button
        v-else
        class="hover:text-gray-200 transition-all duration-300 border border-transparent cursor-pointer rounded flex justify-center items-center px-1"
        :class="{
            ['hover:bg-'+ color +'-900 hover:border-'+ color +'-900 text-'+ color +'-600'] : color,
            ['bg-transparent'] : !color,
        }"
    >
        <Svg
            :name="icon"
            :size="size"
        />
        <slot name="addon" />
    </button>
</template>

<script>
import Svg from 'UI/SvgIcon';

export default {
    components: {
        Svg,
    },
    props: {
        href: String,
        icon: String,
        color: {
            type: String,
            default: 'gray',
        },
        method: {
            type: String,
            default: 'get'
        },
        as: {
            type: String,
            default: 'a'
        },
        size: {
            type: [Number, String],
            default: 26
        }
    }
}
</script>

<style>

</style>
